import PropTypes from "prop-types";

export const mediaElementShape = {
  url: PropTypes.string,
  sizeValue: PropTypes.number,
  onLoad: PropTypes.func,
  onDownload: PropTypes.func,
  progress: PropTypes.number,
  // onClick: PropTypes.func,
};
